export const NAME_XS = 5;
export const EXAM_XS = 12 - NAME_XS;

export const SCORE_XS = 3;
export const PERCENT_XS = 3;
export const ATTEMPTS_XS = 3;
export const BUTTON_XS = 12 - SCORE_XS - PERCENT_XS - ATTEMPTS_XS;
